// extracted by mini-css-extract-plugin
export default {"wrapper":"RzBD_M"};